import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';
import CustomNotify from '../components/Notify';

const { dispatch } = store;
const defEvents = {
    before: AppConstants.POSTBACK_HISTORY_START_LOADING,
    success: AppConstants.POSTBACK_HISTORY_SUCCESS,
    fail: AppConstants.POSTBACK_HISTORY_FAIL
};

const PostbackHistoryActions = {
    getListHistoryPostbacks(params, callback, events = defEvents) {
        dispatch({
            type: events.before
        });

        return api.searchPostbackQueue(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                return data.response || {};
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type  : events.fail,
                        error : err.error
                    });
                });
            });
    },

    resendPostback(params, callback) {
        api.resendPostback(params)
            .then(data => {
                dispatch({
                    type: AppConstants.POSTBACK_SEARCH_LOAD_SUCCESS,
                    items: data.response || {}
                });
                if (data.success) {
                    CustomNotify(data.success);
                }
                callback && callback();
            })
            .catch(error => {
                if (error.error) {
                    CustomNotify(error.error, 'error');
                } else {
                    handleError(error);
                }
            });
    },

    addPostback(params, callback) {
        api.addPostback(params)
            .then(data => {
                dispatch({
                    type: AppConstants.POSTBACK_SEARCH_LOAD_SUCCESS,
                    items: data.response || {}
                });
                if (data.success) {
                    CustomNotify(data.success);
                }
                callback && callback();
            })
            .catch(error => {
                if (error.error) {
                    CustomNotify(error.error, 'error');
                } else {
                    handleError(error);
                }
            });
    }
};

export default PostbackHistoryActions;
